import { getUrlSearchParams } from '../getUrlSearchParams/getUrlSearchParams.util';

export const DeleteQueryParam = (name: string): void => {
  let searchParams: URLSearchParams | null = getUrlSearchParams();
  if (searchParams) {
    searchParams.delete(name);
    let searchString =
      searchParams?.toString().length > 0 ? '?' + searchParams?.toString() : '';
    let newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      searchString +
      window.location.hash;
    history.replaceState(null, '', newUrl);
  }
};
